
import { defineComponent, ref } from "vue";
import { Note } from "../types/note";
import { VueDraggableNext } from "vue-draggable-next";

export default defineComponent({
  name: "Board",
  components: {
    draggable: VueDraggableNext,
  },
  setup() {
    const notes = ref([
      {
        description: "",
        createdAt: new Date(),
      },
    ] as Array<Note>);

    const fontFamily = ref("Cedarville Cursive");
    const addNote = (): void => {
      notes.value.push({
        description: "",
        createdAt: new Date(),
      });
    };

    const removeNote = (index: number): void => {
      notes.value.splice(index, 1);
    };

    const getColor = (): { backgroundColor: string } => {
      const colors = ["#fffd75", "#faaaca", "#69f098", "#ffff88", "#38a1c5"];
      const color = colors[Math.floor(Math.random() * colors.length)];
      return {
        backgroundColor: color,
      };
    };

    return {
      notes,
      fontFamily,
      addNote,
      removeNote,
      getColor,
    };
  },
});
